import { Card, CardContent, CardHeader, Grid } from "@mui/material"
import InfoBox from "../../../../common/InfoBox"
import { DualAxisChart } from "../../../../components/charts/CompositChart"
import { formatNumber, numberPrecision } from "../../../../helpers/UtilityHelper"
import { SERIES_COLORS, STATUS_COLORS, PAYMENT_COLORS, ACCENT } from "../../../charts/colors"

const chartOptions = {
    layout: 'horizontal',
    xaxis: 'name',
    showLabels: true,
    legendAlign: 'left',
    yaxis: {
        left: {
            label: 'Number Of Shipments',
            data: [
                {
                    dataKey: 'pickedUpOrders',
                    label: 'Picked up',
                    chartType: 'bar',
                    fill: SERIES_COLORS[0],
                },
                {
                    dataKey: 'deliveredOrders',
                    label: 'Delivered',
                    chartType: 'line',
                    fill: STATUS_COLORS.DELIVERED,
                },
            ],
        },
        right: {
            label: 'Delivery %',
            tickFormatter: (v) => `${v}%`,
            data: [
                {
                    dataKey: 'deliveryPercentage',
                    label: 'Delivery %',
                    chartType: 'line',
                    unit: '%',
                    fill: ACCENT.blue,
                },
                {
                    dataKey: 'codDeliveryPercentage',
                    label: 'COD Delivery %',
                    chartType: 'line',
                    unit: '%',
                    fill: PAYMENT_COLORS.COD,
                },
                {
                    dataKey: 'prepaidDeliveryPercentage',
                    label: 'Prepaid Delivery %',
                    chartType: 'line',
                    unit: '%',
                    fill: PAYMENT_COLORS.PREPAID,
                },
            ],
        },
    },
}

export default function DeliveryTrends({ data }) {
    return (
        <Card elevation={1}>
            <CardHeader title="Delivery Percentage Trends" />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <InfoBox header={'Picked Shipments'} value={formatNumber(data.pickedUpOrderCount)} />
                    </Grid>
                    <Grid item xs={3}>
                        <InfoBox header={'Delivered Shipments'} value={numberPrecision(data.allForwardDeliveredPercentage * data.pickedUpOrderCount / 100, 0)} />
                    </Grid>
                    <Grid item xs={3}>
                        <InfoBox header={'Delivery %age'} value={numberPrecision(data.allForwardDeliveredPercentage, 2) + " %"} />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <DualAxisChart data={data.lineChartData} chartOptions={chartOptions} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
